import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosObj } from "../../../config/apiClients";
import { OfferState } from "../../types";
import { Offer } from "../../../utils/types";

const initialState: OfferState = {
  isLoading: false,
  offers: []
}

export const getAllOffers = createAsyncThunk(
  "/offer/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get('/offer/getAll');
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch offer List' });
    }
  }
);

export const createOffer = createAsyncThunk(
  "/offer/create",
  async (offer: Offer, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post('/offer/create', offer);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Add Offer' });
    }
  }
)

export const updateOffer = createAsyncThunk(
  "/offer/update",
  async (offer: Offer, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('/offer/update', { ...offer, id: offer._id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Update Offer' });
    }
  }
)

export const deleteOffer = createAsyncThunk(
  "/offer/delete",
  async (offerId: string, { rejectWithValue }) => {
    try {
      const response = await axiosObj.delete('/offer/delete', { data: { offerId } });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Delete Offer' });
    }
  }
)

const offerSlice = createSlice({
  name: "offer",
  initialState,
  reducers: {
    updateOfferItem: (state, action) => {
      const index = state.offers.findIndex((offer) => offer._id === action.payload._id);
      if (index !== -1) {
        state.offers[index] = action.payload;
      }
    },
    deleteOfferItem: (state, action) => {
      state.offers = state.offers.filter((item) => item._id !== action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllOffers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllOffers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.offers = action.payload.payload.kAllOffers;
      })
      .addCase(getAllOffers.rejected, (state) => {
        state.isLoading = false;
        state.offers = [];
      })
      .addCase(createOffer.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createOffer.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(createOffer.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(updateOffer.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateOffer.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateOffer.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteOffer.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteOffer.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteOffer.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

export const { updateOfferItem, deleteOfferItem } = offerSlice.actions;

export default offerSlice.reducer;